var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/modules/$.cof.js
// module id = 99
// module chunks = 0